import { gql } from '@apollo/client';
import { query } from 'services/graphql';
import { notificationDetailsFragment } from 'graphql/user/fragments';

export const notificationsQuery = gql`
  query notifications($input: NotificationsInput) {
    notifications(input: $input) {
      edges {
        node {
          ...notificationDetails
        }
        cursor
      }
      meta {
        totalCount
      }
    }
  }
  ${notificationDetailsFragment}
`;

export default query(notificationsQuery);
